import { render, staticRenderFns } from "./VirtualMachineDiskUsageTop.vue?vue&type=template&id=3ba4355f"
import script from "./VirtualMachineDiskUsageTop.vue?vue&type=script&lang=js"
export * from "./VirtualMachineDiskUsageTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports